import React from 'react'
import { Box, Grid ,} from '@mui/material'
import { DataGrid, GridColumnMenu } from '@mui/x-data-grid';
import dataGridStyle from '../../../styles/dataGridStyle';
import ActionButtons from '../../../components/ActionButtons';

function CustomColumnMenu(props) {
  return (
      <GridColumnMenu
          {...props}
          slots={{
              // Hide `columnMenuColumnsItem`
              columnMenuColumnsItem: null,
              columnMenuSortItem: null,
          }}
      />
  );
}
const columns = [

  { field: 'EstimateNo', headerName: 'No', editable: false, sortable: false, minWidth: 100 },
  { field: 'EnquiryNo', headerName: 'EnquiryNo', editable: false, sortable: false, minWidth: 100 },
  { field: 'EstimateDate', headerName: 'Date', editable: false, sortable: false, minWidth: 100},
  { field: 'PreparedBy', headerName: 'Prepared By', editable: false, sortable: false, minWidth: 100 },
  { field: 'VehicleNo', headerName: 'VRM', editable: false, sortable: false,  minWidth: 100},
  { field: 'Owner', headerName: 'Customer', editable: false, sortable: false, flex: 1 , minWidth: 100},
  { field: 'Mob_No', headerName: 'Mob No: ', editable: false, sortable: false,flex: 1 ,  minWidth: 100},
  { field: 'AppoimentDate', headerName: 'Appoiment ', editable: false, sortable: false,  minWidth: 100},
  { field: 'TotalParts', headerName: 'Total Parts', editable: false, sortable: false, minWidth: 100 },
  { field: 'TotalLabour', headerName: 'Total Labour', editable: false, sortable: false,minWidth: 100 },
  { field: 'NetTotal', headerName: 'Net Total', editable: false, sortable: false, minWidth: 100},
  { field: 'enstatus', headerName: 'Status', editable: false, sortable: false,minWidth: 100 },
  { field: 'action', headerName: 'Actions', sortable: false, flex: 1, minWidth: 180, renderCell: (params) => {
    return (
    <ActionButtons title='Convert To Service Order' status={params.row.enstatus==='Estimate'?true:false} page='add_service_order'/>
    );
    }}
];

 

const rows = [

  { EstimateNo: 1251, EnquiryNo:1234, EstimateDate: '01-02-2023', PreparedBy: 'Lincoln', Owner: 'Oliver Jake Jack Connor',Mob_No:'731-487-0128',AppoimentDate:'05-05-2023', VehicleNo:'KZ66 ZYT', enstatus:'Estimate', TotalParts:5,TotalLabour:1,NetTotal: 358},
  { EstimateNo: 1252, EnquiryNo:1235,EstimateDate: '01-02-2023', PreparedBy: 'William', Owner: 'John Fitzgerald Kennedy',Mob_No:'850-585-7045',AppoimentDate:'05-05-2023', VehicleNo:'PZ65 PWO', enstatus:'Estimate', TotalParts:3,TotalLabour:2,NetTotal: 589},
  { EstimateNo: 1254, EnquiryNo:1239, EstimateDate: '01-02-2023', PreparedBy: 'Ambrose', Owner: 'Liam John Mason Robert',Mob_No:'334-741-0808',AppoimentDate:'05-05-2023', VehicleNo:'HZ13 WDD', enstatus:'Service', TotalParts:6,TotalLabour:4,NetTotal: 890},
  { EstimateNo: 1255, EnquiryNo:1241, EstimateDate: '01-02-2023', PreparedBy: 'Aloysius', Owner: 'Christopher Dominic Gabriel',Mob_No:'850-585-7045',AppoimentDate:'05-05-2023', VehicleNo:'PZ65 BYV', enstatus:'Estimate', TotalParts:2,TotalLabour:2,NetTotal: 520},
  ];
function AllEstimate() {
  return (
    <Grid item xs={12} mt={1}>
              <Box sx={dataGridStyle.root}>
              <DataGrid
              columnHeaderHeight={42}
              rowHeight={40}
              rows={rows}
              columns={columns}
              getRowId={(row) => row.EstimateNo}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              pageSizeOptions={[10]}
              slots={{ columnMenu: CustomColumnMenu }}
              disableRowSelectionOnClick
            />
          </Box>
        </Grid>
  )
}

export default AllEstimate